const Vision = () => {
    return (
        <main className='main-container'>
            <div className="main-wrapper">
                <section className="review-area pb-100 pt-40" id="vision">
                    <div className="container">
                        <div className="row justify-content-start align-items-center">
                            <div className="col-lg-6 video-left">
                                <br/>
                                <header className='pt-120'>
                                    <h1 className="page-heading">Vision</h1>
                                </header>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="video-sec-area pb-100 pt-40" id="about">
                    <div className="container">
                        <div className="row justify-content-start align-items-center">
                            <article className="col-lg-6 video-left">
                                <p>
                                    To cultivate a thriving Baptist community where believers are deeply rooted in biblical truth, equipped through comprehensive education in doctrine and devotion, and empowered to navigate life's challenges with faith and wisdom, while extending support to village ministries and churches worldwide to advance Gospel.
                                </p>
                            </article>
                        </div>
                    </div>
                </section>
            </div>
        </main>
    );
}
export default Vision;